var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFeatureBackground = function SvgFeatureBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 973,
    height: 254,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.692 73.74C227.836-75.019 478.547-77.523 990.547-27.93v302.907H0c7.074-7.938 54.062-3.957 60-20.477 39-108.5 129.547-32 148.692-180.76Z",
    fill: "#F8F9FC"
  })));
};
export { SvgFeatureBackground as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTczIiBoZWlnaHQ9IjI1NCIgdmlld0JveD0iMCAwIDk3MyAyNTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yMDguNjkyIDczLjc0MDRDMjI3LjgzNiAtNzUuMDE5IDQ3OC41NDcgLTc3LjUyMzMgOTkwLjU0NyAtMjcuOTI5OFYyNzQuOTc3SDBDNy4wNzQ0IDI2Ny4wMzkgNTQuMDYxOCAyNzEuMDIgNjAgMjU0LjVDOTkgMTQ2IDE4OS41NDcgMjIyLjUgMjA4LjY5MiA3My43NDA0WiIgZmlsbD0iI0Y4RjlGQyIvPgo8L3N2Zz4K";